import {combineReducers, createStore} from "redux";
import * as actions from './actions';
import {iConfig} from "./interfaces";
import {iSetConfig, iSetMetric, iSetPeriod, iSetQuarter, iSetYear} from "./actions";
import * as cnst from './const';


function config(state: iConfig = {npmrdsYears: [], yearQuarter: {}}, action: iSetConfig) {
    if (action.type === actions.SET_CONFIG) {
        return action.config;
    } else {
        return state;
    }
}

function year(state: number = null, action: iSetYear) {
    if (action.type === actions.SET_YEAR) {
        return action.year;
    } else {
        return state;
    }
}

function quarter(state: number = null, action: iSetQuarter) {
    if (action.type === actions.SET_QUARTER) {
        return action.quarter;
    } else {
        return state;
    }
}

function period(state: string = cnst.TIME_PERIODS[0], action: iSetPeriod) {
    if (action.type === actions.SET_PERIOD) {
        return action.period;
    } else {
        return state;
    }
}

function metric(state: string = cnst.METRICS[0], action: iSetMetric) {
    if (action.type === actions.SET_METRIC) {
        return action.metric;
    } else {
        return state;
    }
}

export const store = createStore(
    combineReducers({config, year, quarter, period, metric})
);


export interface iState {
    config: iConfig;
    year: number;
    quarter: number;
    period: string;
    metric: string;
}

export function getState(): iState {
    return store.getState() as iState;
}


export default store;